module.exports = __webpack_public_path__ + "964c987d9d7aa78110b156972e939225.png";


//////////////////
// WEBPACK FOOTER
// ./images/vipcz/wei-jingjing.png
// module id = 607
// module chunks = 30